import { whatIfInnerSelector } from '../../WhatIfsSelector';

export const inflationSelector = (state, props) =>
  whatIfInnerSelector(state, props).Inflation * 100;

export default null;
